// import ChangesMonitor from 'src/constrains/SalesChannelContent-Revamp/HomePageChangesMonitor';
import ContentGrid from '@/src/components/SalesChannelComponents/SalesChannelContentGrid';
import { get } from 'lodash';
import { useAllProductsPage } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage-revamp/hooks/useAllProductsPage';
import Wrapper from 'src/constrains/SalesChannelContentWrapperRevamp';
// import { SalesChannelStatus } from '@/src/types/common/SalesChannel';
import React from 'react';
import { Form } from '@/src/components/RcForm';
import Visible from '@/src/components/Modules-revamp/Visible';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import Top from './TopLeaderBoardBanner';
import Menu from './Menu';
import Grid from './ProductGridSetting';
import ChangesMonitor from 'src/pages/SalesChannelContentEditor/Components/ChangeMonitor';
import { getI18nFromGeneral } from 'src/tools/tools';
import RouteBlock from 'src/constrains/RouterBlock/RouterBlock';
import { formButtonList } from '@/src/strategies/util';
import { isPrimaryLanguage } from '@/src/constrains/SalesChannelMultiLanguageSelect/slice';
import { useSelector } from 'react-redux';
const AllProductsPage = () => {
  const {
    salesChannel,
    hasModified,
    onGoBack,
    buttons,
    pcForm,
    mobileForm,
    tabletForm,
    loaded,
    setHasModified,
    handleValuesChange,
    handleOnSubmit,
    handleOnDiscard,
    handleOnReset,
    handleOnCopy,
    data,
  } = useAllProductsPage();
  const isPrimary = useSelector(isPrimaryLanguage());
  const headerProps = {
    title: get(salesChannel, 'name'),
    description: get(data, 'salesChannelContent.versionName'),
    status: get(data, 'salesChannelContent.status'),
    hasModified,
    onSubmit: handleOnSubmit,
    onDiscard: handleOnDiscard,
    onGoBack,
  };

  const commonProps = {
    handleOnSectionReset: handleOnReset,
    handleOnSectionCopy: handleOnCopy,
  };
  return (
    <Wrapper headerProps={headerProps}>
      <ChangesMonitor
        loaded={loaded}
        setHasModified={setHasModified}
        pcForm={pcForm}
        tabletForm={tabletForm}
        mobileForm={mobileForm}
      />
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.discard_content')}
      />
      <ContentGrid
        configCols={[
          {
            child: (
              <Form form={pcForm} onValuesChange={handleValuesChange}>
                <Visible alwaysVisible breakpoint={EPreviewSize.WIDE} />
                <Top breakpoint={EPreviewSize.WIDE} />
                <Menu breakpoint={EPreviewSize.WIDE} />
                {isPrimary && (
                  <Grid
                    breakpoint={EPreviewSize.WIDE}
                    options={formButtonList(buttons || [])}
                  />
                )}
              </Form>
            ),
          },
          {
            child: (
              <Form form={tabletForm}>
                <Visible alwaysVisible breakpoint={EPreviewSize.TABLET} />
                <Top breakpoint={EPreviewSize.TABLET} {...commonProps} />
                <Menu breakpoint={EPreviewSize.TABLET} disabled />
                {isPrimary && (
                  <Grid
                    {...commonProps}
                    breakpoint={EPreviewSize.TABLET}
                    options={formButtonList(buttons || [])}
                  />
                )}
              </Form>
            ),
          },
          {
            child: (
              <Form form={mobileForm}>
                <Visible alwaysVisible breakpoint={EPreviewSize.MOBILE} />
                <Top breakpoint={EPreviewSize.MOBILE} {...commonProps} />
                <Menu breakpoint={EPreviewSize.MOBILE} disabled />
                {isPrimary && (
                  <Grid
                    {...commonProps}
                    breakpoint={EPreviewSize.MOBILE}
                    options={formButtonList(buttons || [])}
                  />
                )}
              </Form>
            ),
          },
        ]}
        mainCol={null}
      />
    </Wrapper>
  );
};
export default AllProductsPage;
